


















































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
class SiteConfigModel {
  enableSms: boolean = false;
  adminPhones: string = "";
  hotLine: string = "";
  keyWords: string = "";
  description: string = "";
  shareCouponAmount: number = 0;
  callCenterStartTime: string = "";
  callCenterEndTime: string = "";
  refundCycle: number = 0;
  enableAutoRefuseRefund: boolean = false;
  newCouponAmount: number = 0;
  orderPayCycle: number = 0;
  complaintLine: string = "";
  emergencyLine: string = "";
  tianDiTuKey: string = "";
  appVersion: string = "";
  pushNumberByBaiDu: number = 10;
  pushNumberByBiYing: number = 10;
  appUrl: string = "";
  secondHandRisk:string = "";
  signName:string = "";
}
@Component({
  components: {},
})
export default class SiteConfig extends AbpBase {
  siteConfigModel: SiteConfigModel = new SiteConfigModel();
  spinShow: boolean = false;
  mounted() {
    this.getSiteConfigs();
  }
  async getSiteConfigs() {
    let rep = await Ajax.get("/api/services/app/SiteConfig/GetSiteConfigs");
    Util.extend(true, this.siteConfigModel, rep.data.result);
  }
  async saveSiteConfig() {
    (this.$refs.configForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.spinShow = true;
        await Ajax.post(
          "/api/services/app/SiteConfig/SetSiteConfig",
          this.siteConfigModel
        );
        this.spinShow = false;
        this.$Modal.success({
          title: "提示信息",
          content: "保存站点设置成功！",
        });
      }
    });
  }
  configRule = {
    adminPhones: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("AdminPhones")),
        trigger: "blur",
      },
    ],
    hotLine: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Hotline")),
        trigger: "blur",
      },
      // {
      //     pattern: /(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/,
      //     message: this.L("IncorrectFormat",undefined,this.L("Hotline")),
      //     trigger: "blur"
      // }
    ],
    complaintLine: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("ComplaintLine")),
        trigger: "blur",
      },
    ],
    emergencyLine: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("EmergencyLine")),
        trigger: "blur",
      },
    ],
  };
}
